import { GlobalState } from '../comps/GlobalContext'
import useGlobalState from './useGlobalState'

export function useGlobalSubState<K extends keyof GlobalState>(key: K) {
    const subState = useGlobalState((s) => s[key])
    const setState = useGlobalState((s) => s.setState)
    const setSubState = (value: GlobalState[K]) =>
        setState({ [key]: value } as Pick<GlobalState, K>)

    return [subState, setSubState] as const
}
